<template>
  <div>
    <Fontnavbar title="售后列表" />
    <van-tabs v-model="active" sticky animated @change="exchange_active">
      <van-tab :title="vo.title" v-for="(vo, voi) in active_name" :key="voi">
        <div class="list-item">
          <!-- order -->
          <van-panel v-for="(item, i) in order" :key="i" class="order_list--panel" :title="'订单号：' + item.order_no" :status="'类型：' + item.after_type_text" @click="goPage('/service/servicedeteil?id=' + item.id + '&after_status=' + item.after_status)">
            <van-row type="flex" justify="space-around" class="label_tar">
              <van-col span="22">退款单号: {{ item.refund_no }}</van-col>
            </van-row>
            <van-row type="flex" justify="space-around" class="label_tar">
              <van-col span="22">申请时间: {{ item.create_time_text }}</van-col>
            </van-row>
            <van-row type="flex" justify="space-around" class="label_tar">
              <van-col span="22">售后状态: {{ item.after_status_text }}</van-col>
            </van-row>
            <div>
              <van-card class="order_list--van-card" :title="item.goods[0].goods_name" :thumb="imgDomain + '' + item.goods[0].goods_thumb_path" style="background-color:#fff;">
                <template #price>
                  <van-tag class="points-tag" style="margin: 10px auto;" size="medium" plain type="warning">￥{{ item.goods[0].goods_price}}</van-tag>
                  x{{ item.goods[0].goods_num }}
                </template>
                <template #num>
                  <van-button type="danger" size="mini" v-if="item.after_status == 20 || item.after_status == 30" @click.stop="cancel(item.id)"> 取消 </van-button>
                  <van-button type="primary" size="mini" v-if="item.after_status == 20" @click.stop="modify(item.id)"> 修改 </van-button>
                  <van-button type="info" size="mini" v-if="(item.after_status == 10 || item.after_status == 11) && item.order.able_after_sales == 1" @click.stop="resubmit(item.id)"> 重新提交 </van-button>
                  <van-button type="warning" size="mini" v-if="item.after_status == 30" @click.stop="ship(item.id)"> 我已寄出，填写单号 </van-button>
                </template>
              </van-card>
            </div>
          </van-panel>

          <div class="empty" v-if="order.length == 0">暂时没有相关数据！</div>
          <!-- 页面加载 -->
          <!-- <div v-if="loading" style="text-align: center">
            <van-loading size="24px">加载中...</van-loading>
          </div> -->
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
    import { get_order_after_list, cancel } from "../../api.js";
    import { post } from "../../request.js";
    import Fontnavbar from "../../components/Navbar.vue";
    import { Dialog } from "vant";
    import { Loading, Toast, Panel, NavBar, Divider, Icon, Button, Tag, Tab, Tabs, Card, PullRefresh, Col, Row } from "vant";

    export default {
        components: {
            [Loading.name]: Loading,
            [PullRefresh.name]: PullRefresh,
            [Toast.name]: Toast,
            [Panel.name]: Panel,
            [NavBar.name]: NavBar,
            [Divider.name]: Divider,
            [Icon.name]: Icon,
            [Tag.name]: Tag,
            [Button.name]: Button,
            [Card.name]: Card,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Col.name]: Col,
            [Row.name]: Row,
            Fontnavbar,
        },

        data() {
            return {
                imgDomain: process.env.VUE_APP_IMG_URL,
                active: 0,
                active_name: [
                  { title: '全部', after_status: '' },
                  { title: '已取消', after_status: '10' },
                  { title: '被拒绝', after_status: '11' },
                  { title: '申请中', after_status: '20' },
                  { title: '申请通过', after_status: '30,45' },
                  { title: '待商家收货', after_status: '35,40' },
                  { title: '已完成', after_status: '60' },
                ],
                order: [],
                after_status: "", //订单状态
                loading: true,
                page: 1, //当前页
                backserve: "",
            };
        },

        mounted() {
            if (this.$store.state.user.loginStatus !== 1) {
                this.$router.push({ path: "/user/login" });
                return false;
            }
            const that = this;
            if (that.$route.query.after_status) {
                that.after_status = parseInt(that.$route.query.after_status);
                that.active = parseInt(that.$route.query.active);
            }

            that.get_order_list(that.after_status);
        },

        methods: {
            // 跳转
            goPage(path) {
                this.$router.push({ path: path });
            },
            //取消订单
            cancel(id) {
                post(cancel, { id: id }).then((res) => {
                    if (res.code == 200) {
                        Dialog({ message: "取消成功" }).then(() => {
                            this.$router.go(0);
                        });
                    } else {
                        Dialog({ message: res.msg }).then(() => {
                            this.$router.go(0);
                        });
                    }
                });
            },
            //修改
            modify(id) {
                this.$router.push({
                    path: '/service/modify',
                    query:{
                        id:id
                    }
                });
            },
            //重新提交
            resubmit(id) {
                this.$router.push({
                    path: '/service/resubmit',
                    query:{
                        id:id
                    }
                });
            },
            //发货
            ship(id){
                this.$router.push({
                    path: '/service/ship',
                    query:{
                        id:id
                    }
                });
            },

            //切换tab
            exchange_active(index) {
                this.page = 1;
                this.order = [];
                this.get_order_list(this.active_name[index].after_status);
            },

            //获取订单列表
            get_order_list(after_status) {
                const that = this;
                var loading = Toast.loading({
                    message: "加载中...",
                    forbidClick: true,
                    loadingType: "spinner",
                    duration: 0,
                });
                post(get_order_after_list, { after_status: after_status, page: that.page }).then((res) => {
                    loading.clear();
                    if (res.code == 200) {
                        if (that.page == 1) {
                            that.order = res.data.list;
                        } else {
                            that.order = that.order.concat(res.data.list);
                        }
                        if (res.data.list.length == 0) {
                            that.loading = false;
                        }
                    } else if (res.code == 201) {
                        this.$router.push({ path: "/user/login" });
                        return false;
                    } else {
                        Toast("网络错误");
                    }
                });
            },
        },
    };
</script>

<style lang="less" scoped>
  .order_list--panel {
    margin-bottom: 10px;
    .van-cell__title {
      min-width: 70%;
    }
  }
  .order_list--panel span {
    font-size: 12px;
  }
  .order_list--total {
    text-align: right;
    padding: 10px;
    border: 1px solid #fafafa;
  }
  .order_list--footer_btn {
    background-color: #fff;
    padding: 10px;
  }

  .order_list--footer_btn button {
    float: right;
    margin: 5px;
  }
  .empty {
    margin-top: 40%;
    text-align: center;
  }
  .label_tar{
    font-size: 10px;
    line-height: 30px;
  }
</style>
